import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import DataTable from "react-data-table-component";
import { Button } from "react-bootstrap";
import { customStyles } from "../../utils/data/essential";
import { CSVLink } from "react-csv";
import { accountHeaders } from "../../utils/data/reportData";
import Locations from "../../Component/Locations";
import { selectLocationName } from "../../redux/slice/LocationNameSlice";
import { useFetchData } from "../../hooks/useFetchData";
import { accountsPendingApprovalColumns } from "../../utils/columns/accountsPendingApprovalColumns";
import moment from "moment";
const AccountPendingApproval = () => {
  const [loading, setLoading] = useState(false);
  const locations = JSON.parse(localStorage.getItem("locations"));
  const [locationId, setLocationId] = useState(locations[locations.length - 1].id);
  console.log("Location id:", locationId);
  const [accountData, setAccountData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [enableFilter, setEnableFilter] = useState(false);
  const [dataToSearchFrom, setDataToSearchFrom] = useState([]);
  const [exportData, setExportData] = useState([]);
  const locationName = useSelector(selectLocationName);
  const selectedLocation = locationName;
  const columns = accountsPendingApprovalColumns(selectedLocation);
  const user = JSON.parse(localStorage.getItem("user"));
  const extractExportData = (data) => {
    let obj = {};
    let arr = [];
    data?.forEach((el) => {
      obj.id = el.id;
      obj.type = el.type.name;
      obj.datetime = el.datetime;
      obj.accountNumber = el.accountNumber;
      obj.accountName = el.accountName;
      obj.monthlyFee = el.monthlyFee;
      obj.amount = el.amount;
      obj.outstandingAmount = el.outstandingAmount;
      obj.status = el.status.name;
      obj.accountId = el.accountId;
      obj.locationName = selectedLocation;
      obj.createdAt = moment(el.createdAt).format("DD/MM/YYYY");
      arr.push(obj);
      obj = {};
    });
    setExportData(arr);
  };
  // Fetch accounts data
  const url = `accounts?statusId=0&locationId=${locationId}`;
  const { data, refetch } = useFetchData(["fetch-pending-accounts"], url, false,user);
  useEffect(() => {
    setLoading(false);
    setEnableFilter(true)
    // const newAccounts = data?.filter((dt) => dt.status.name.toLowerCase() === "new");
    setAccountData(data);
    setDataToSearchFrom(data);
    extractExportData(data);
  }, [data]);
  const datafromChildComponent = (data) => {
    setLocationId(data.locationId);
  };
  const handleSearch = () => {
    const newAccountData = dataToSearchFrom.filter(
      (dt) =>
        dt?.accountName?.toLowerCase().includes(keyword.toLowerCase()) ||
        dt?.accountNumber?.includes(keyword) ||
        dt?.id?.toString().includes(keyword)
    );
    if (newAccountData) {
      setAccountData(newAccountData);
    }
  };
  return (
    <div>
      <div className='d-flex justify-content-center mb-4 mt-3'>
        <h3 className='ml-3'>Pending approval accounts</h3>
      </div>
      <div style={{ backgroundColor: "#dfdfdf", height: 3 }} />
      <Locations sendDataToParent={datafromChildComponent} />
      <div className='d-flex justify-content-center'>
        <Button
          style={{ backgroundColor: "#124db1" }}
          onClick={() => {
            setLoading(true);
            refetch();
          }}
        >
          {loading ? "Loading..." : "Search"}
        </Button>
      </div>
      {data?.length > 0 && (
        <div className='flex-container'>
          <div className='quick-search-container'>
            <input
              type='text'
              className='form-control quick-search'
              placeholder='Quick search by name,phone or Id'
              onChange={(e) => setKeyword(e.target.value)}
              onKeyUp={handleSearch}
              style={{ marginBottom: data?.length === 0 ? 50 : "" }}
            />
          </div>
        </div>
      )}
      {accountData?.length > 0 && (
        <div className='d-flex justify-content-end mr-3'>
          <CSVLink
            data={exportData}
            headers={accountHeaders}
            filename={`Pending_accounts_in_${locationName}`}
          >
            <button
              type='button'
              className='btn btn-primary housesTableFilterBtn'
              disabled={accountData?.length === 0}
              style={{
                backgroundColor: data?.length === 0 ? "#cbcbcb" : "#124db1",
                color: accountData?.length === 0 ? "#000" : "",
                cursor: accountData?.length === 0 ? "default" : "pointer",
              }}
            >
              Excel{" "}
              <i
                style={{ marginLeft: "1rem" }}
                className='fas fa-file-excel'
              ></i>
            </button>
          </CSVLink>
        </div>
      )}

      <div className='table-responsive datatables dataValidation-Wrap thead-primary pr-3 pl-3 mr-2'>
        <DataTable
          columns={columns}
          data={accountData}
          responsive={true}
          customStyles={customStyles}
          pagination
          highlightOnHover
          striped
          noHeader
        />
      </div>
    </div>
  );
};

export default AccountPendingApproval;
